export const projectsData = [
     {
        "projectTitle": "Product Reviews App",
        "projectOverview": "This is the Product Reviews App, built with ASP.NET where you can read and write reviews for the products and give them a star rating out of 5. \n\n You are also able to sort the products based on whether they are new or used, or any to review you can also filter more by looking for only products that are on sale within those categories (new, used, or any).",
        "projectTech": [
            "ASP.NET",
            "MySQL"
        ],
        "image": "/assets/images/product-reviews.jpeg",
        "link": ""
    },
    {
        "projectTitle": "Photo Album",
        "projectOverview": "This is the Photo Album App, built using Next.js. With this app, you can easily add as many photos as you like to your database. \n\n Once added, you can “flip” through them using the next and previous buttons, or you can use the “jump” button to view all the thumbnails for your images, and then click on the one you want to “jump” to. \n\n One of the best things about this app is that you can also add comments to each photo!",
        "projectTech": [
            "MySQL",
            "Nextjs",
            "PHP"
        ],
        "image": "/assets/images/photo-album.jpeg",
        "link": ""
    },
    {
        "projectTitle": "Launch Pad",
        "projectOverview": "This is the Launch Pad App built with ASP.NET, there is a public view as well as an Admin view for this app. \n\n The public view is what you see pictured. The admin view looks almost the same but you have the added ability of being able to add, edit, and delete the links as well as edit the category titles. You can also pin your most used links to the top section of the category it’s in for added convenience. \n\n This app is super handy for managing all of your common links that you need access to, you can just add them here, and instead of needing to remember a bunch of URLs you only need to remember the launch pad to easily find what you’re looking for.",
        "projectTech": [
            "ASP.NET",
            "MySQL"
        ],
        "image": "/assets/images/launch-pad.jpeg",
        "link": ""
    },
    {
        "projectTitle": "Capstone – Class Scheduling Web App",
        "projectOverview": "This project represents my team’s progress for our Capstone Course. Our focus was on developing a complex schedule-generating app using ASP.NET, that has both user and admin interfaces. \n\n The administrative functionality enables admin users to manage courses, faculty, rooms, and programs easily. Within this system, the administrator enters all the data needed for the programs (this includes courses, faculty that teach those courses, and the technology needed for the classroom, etc.) the system will then generate 5 randomized master schedules that the administrator can choose from. \n\n Faculty members benefit from a personalized experience as they log in to access, print, and review their schedules. They also can look at other faculty members’ schedules, so they are easily able to communicate or meet up with their coworkers when they need to. \n\n My specific contribution to this project is the UI/UX portion, keeping track of meeting minutes for both client meetings as well as internal team meetings, updating the client on progress, getting sprint sign-offs, as well as creating the project charter.",
        "projectTech": [
            "ASP.NET",
            "MySQL"
        ],
        "image": "/assets/images/capstone.jpeg",
        "link": ""
    },
    {
        "projectTitle": "Personal Portfolio Version-1",
        "projectOverview": "During my self-directed study on AWS, I decided to incorporate the creation of my portfolio into my final project. I chose to deploy my portfolio website using an AWS EC2 instance. \n\n For building my portfolio, I opted for WordPress and created a custom theme to give it a personal touch. I also added custom post types specifically for showcasing projects on my sample page, making it more tailored to my specific needs.",
        "projectTech": [
            "JS",
            "PHP",
            "Wordpress"
        ],
        "image": "/assets/images/portfolio-v1.jpeg",
        "link": ""
    },
    {
        "projectTitle": "Tech Roster Admin",
        "projectOverview": "The Tech Roster App showcased here was created using Next.js, offering functionality to manage technologies and courses through the CRUD (Create, Read, Update, Delete) approach. \n\n Users can easily add new entries, make edits as needed, and remove outdated information, thereby ensuring an efficient and organized system for tracking and managing tech-related data and educational content.",
        "projectTech": [
            "Nextjs"
        ],
        "image": "/assets/images/tech-roster.jpeg",
        "link": ""
    }
];